
import { addFormatApi, addInvoiceFormatApi, changeDefaultStatusApi, deleteFormatFromBranch, fetchBranchDetailsData, getAllCompanyFormateApi, getAllInviceFormatByCompany, getAllLrFormateApi, getAllLrFormatebyBranch } from '_services/accountsServices/branchServices';
import { CommonInput, CommonTextarea, CommonToast, CrossButton, CustomSelect } from 'components';
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import { AppConfig } from 'lib';
import Loading from 'pages/Loading';
import React, { useContext, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { IoSettingsOutline } from 'react-icons/io5'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { RxDragHandleDots2 } from 'react-icons/rx';
import { useParams } from 'react-router-dom';
import { StorageServices } from 'utils';
import './invoiceFormate.css'
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { ConfirmModalFor } from 'modals';
import { Images } from 'constants';
import { UserContext } from 'context';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { Format1, Format2, Format3, Format4 } from './CompanyInvoceFormat';


const InvoiceFormat = ({ onDataFetch }) => {
    let { id } = useParams();
    const BASE_URL = AppConfig.api_baseurl// 'https://transportapi.urja360.com/';
    const [showAddNewFormat, setShowAddNewFormat] = useState(false);
    const [showLrSetting, setShowLrSetting] = useState(false);
    const [formatList, setFormatList] = useState([]);
    const [branchLrFormate, setBranchLrFormate] = useState([]);
    const [claimFormate, setClaimFormate] = useState([]);
    const [supplementaryFormate, setSupplementaryFormate] = useState([]);
    const [isLrLoading, setIsLrLoading] = useState(false);
    const [isLrBranchLoading, setIsLrBranchLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [loadingId, setLoadingId] = useState(null);
    const companyId = StorageServices.getCompanyId();
    const [isSelected, setIsSelected] = useState([]);
    const [activeTab, setActiveTab] = useState(1);
    const [form, setForm] = useState("")
    const hasFetchedOnce = useRef(false);
    const [deleteLoadding, setDeleteLoadding] = useState(false)
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState(null);
    const hasSetDefaultRef = useRef(false);
    const [detailsData, setDetailsData] = useState({})
    const { masterData } = useContext(UserContext)
    const tabProps = {
        tabList: constant.InvoiceSettingFormatTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab
    }
    // drag---------------


    const dummyOption = [
        { label: 'New York', value: 'ny' },
        { label: 'Los Angeles', value: 'la' },
        { label: 'Chicago', value: 'ch' },
        { label: 'Houston', value: 'ho' },
        { label: 'Phoenix', value: 'ph' }
    ]

    const invoiceFields = [
        "Invoice Number",
        "PO Number",
        "Field 1",
        "Field 2",
        "Field 3",
        "Field 4",
        "Field 5",
        "Indent Number",
        "MLR",
        "LR Number",
        "Eway Number",
        "POD Number"
    ].map(field => ({
        label: field,
        value: field
    }));

    const secondColFields = [
        "LR Date",
        "Dispatch Date",
        "Indent Date"
    ].map(field => ({
        label: field,
        value: field
    }));

    const FormatList = {
        1: <Format1 modifyForm={form} />,
        2: <Format2 modifyForm={form} />,
        3: <Format3 modifyForm={form} />,
        4: <Format4 modifyForm={form} />,

    }


    const handleChange = (e, selectValue = null) => {
        // For select components
        if (selectValue !== null) {
            const { name } = e.target;
            const [parent, child] = name.split('.');
            setForm(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: selectValue
                }
            }));
            return;
        }

        // For regular input changes
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setForm(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setForm(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5,
            },
        })
    );

    // Drag End Handler
    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!over) return; // exit if dragged outside

        if (active.id !== over.id) {
            const oldIndex = form.lr_table.findIndex((i) => i.name === active.id);
            const newIndex = form.lr_table.findIndex((i) => i.name === over.id);

            if (oldIndex !== -1 && newIndex !== -1) {
                const newItems = arrayMove(form.lr_table, oldIndex, newIndex);
                setForm((prev) => ({
                    ...prev,
                    lr_table: newItems,
                }));
            }
        }
    };

    // drag---------------


    useEffect(() => {
        if (!showAddNewFormat) {
            getBranchLrFormat(companyId, id)
        }
    }, [])

    useEffect(() => {
        if (showAddNewFormat) {
            getAllLrFormate(companyId)
        }
    }, [showAddNewFormat])

    useEffect(() => {

        if (hasSetDefaultRef.current && isSelected.length === 1) {
            hasSetDefaultRef.current = false;
            changeDefaultStatus(1, isSelected[0]?._id);
        }
    }, [isSelected]);

    const getDataBranchDetails = async (id_1, id_2) => {
        try {
            let object = {
                branch_id: id_1,
                company_id: id_2,
            }
            const res = await fetchBranchDetailsData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data?.branch)
                onDataFetch(res?.data?.branch)
                // setLoading(false);
            } else {
                // setLoading(false);
            }
        } catch (error) {
            // setLoading(false);
            // throw error;
        }
    }

    useEffect(() => {
        if (id) {
            // setLoading(true);
            getDataBranchDetails(id, companyId);
        }
    }, [id, masterData])


    const handleAddNewFormatClick = () => {
        setShowAddNewFormat(true);
    };
    const handleSettingsClick = () => {
        setShowLrSetting(true);
    };

    const handleDeleteClick = (event, item) => {
        event.stopPropagation()
        setConfirmModalShow(item);
    }

    const getBranchLrFormat = async (company_id) => {

        const payload = {
            company_id,
        }

        try {
            if (!hasFetchedOnce.current) {
                setIsLrBranchLoading(true); // Only show loader the first time
            }
            const res = await getAllInviceFormatByCompany(payload)
            if (res?.responseCode == 200) {
                setBranchLrFormate(res?.data?.formats)

                const formatPromises = res?.data?.formats?.map(async (rf) => {
                    const response = await fetch(`${BASE_URL}${rf.template_img}`);
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);

                    return {
                        ...rf,
                        imageUrl: blobUrl
                    };
                });

                const ModifyFormate = await Promise.all(formatPromises); // Wait for all async tasks
                setBranchLrFormate(ModifyFormate);
                setIsSelected(res?.data?.formats);

            }

        } catch (error) {

        } finally {
            //   if (!hasFetchedOnce.current) {
            setIsLrBranchLoading(false);
            hasFetchedOnce.current = true; // Prevent future loading flags
            //   }
        }
    }
    const getAllLrFormate = async (company_id) => {
        setIsLrLoading(true);

        try {
            const res = await getAllCompanyFormateApi();

            if (res?.responseCode === 200) {
                const formatPromises = res?.data?.formats?.map(async (rf) => {
                    const response = await fetch(`${BASE_URL}${rf.template_img}`);
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);

                    return {
                        ...rf,
                        imageUrl: blobUrl
                    };
                });

                const ModifyFormate = await Promise.all(formatPromises); // Wait for all async tasks
                setFormatList(ModifyFormate);
            }
        } catch (error) {
            console.error("Failed to load LR formats", error);
        } finally {
            setIsLrLoading(false);
        }
    };



    const onToggleMain = (name) => {
        setForm(prev => ({
            ...prev,
            lr_table: prev.lr_table.map(field => {
                if (field.name !== name) return field;

                const newValue = !field.check;

                return {
                    ...field,
                    check: newValue,
                    select: Array.isArray(field.select)
                        ? field.select.map(opt => ({
                            ...opt,
                            check: newValue ? opt.check : false // uncheck all if parent is unchecked
                        }))
                        : field.select
                };
            })
        }));
    };



    const onToggleSelect = (parentName, optionName) => {
        setForm(prev => ({
            ...prev,
            lr_table: prev.lr_table.map(field => {
                if (field.name !== parentName) return field;

                const updatedSelect = field.select.map(opt =>
                    opt.name === optionName ? { ...opt, check: !opt.check } : opt
                );

                const anyChildChecked = updatedSelect.some(opt => opt.check);

                return {
                    ...field,
                    check: anyChildChecked || field.check, // parent gets checked if any child is checked
                    select: updatedSelect
                };
            })
        }));
    };

    const handleDelete = async () => {

        const payload = {
            company_id: companyId,
            format_id: confirmModalShow?._id
        }

        toast.success("comming soon..")
        // setDeleteLoadding(true)

        // try {

        //     const res = await deleteFormatFromBranch(payload)
        //     if (res?.responseCode == 200) {
        //         setDeleteLoadding(false)
        //         toast.success(res.responseMessage)
        //         setConfirmModalShow(false)
        //         getBranchLrFormat(companyId)
        //     } else {
        //         setDeleteLoadding(false)
        //         // toast.error(res.responseMessage)
        //     }

        // } catch (error) {
        //     setDeleteLoadding(false)
        //     // toast.success(res.responseMessage)
        // }
    }

    const handleUpdate = async (activeTab) => {
        const frDetailsWithoutImage = { ...form };
        delete frDetailsWithoutImage.imageUrl;

        if (activeTab == 1) {
            setActiveTab(2)
        } else {
            const payload = {
                company_id: companyId,
                format: frDetailsWithoutImage
            }

            try {
                setIsUpdateLoading(true)
                const res = await addInvoiceFormatApi(payload)
                if (res?.responseCode === 200) {
                    toast.success(res?.responseMessage || "Add Successfully")
                    setIsUpdateLoading(false)
                    setShowLrSetting(false)
                    getBranchLrFormat(companyId)
                    setActiveTab(1)

                } else {
                    setIsUpdateLoading(false)
                }
            } catch (error) {
                setIsUpdateLoading(false)
            }
        }


    }


    const handleChangeDefaultStatus = (event, formatId, index) => {
        const checkedValue = event.target.checked == true ? 1 : 0

        if (formatId) {
            changeDefaultStatus(checkedValue, formatId)
        }
    }

    const changeDefaultStatus = async (checkedValue, formatId) => {

        const payload = {
            company_id: companyId,
            branch_id: id,
            format_id: formatId,
            is_default: checkedValue,
        };

        try {
            const res = await changeDefaultStatusApi(payload);

            if (res?.responseCode === 200) {
                // Refetch updated formats

            } else {
                toast?.error(res?.responseMessage || "Failed to update status.");
            }

            getBranchLrFormat(companyId);
        } catch (error) {
            toast?.error(error?.message || "Something went wrong.");
            getBranchLrFormat(companyId);
        }
    };


    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => {
            setConfirmModalShow(false);
        },
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: handleDelete,
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoadding,
        disabled: deleteLoadding
    };



    function SortableItem({ item, onToggleMain, onToggleSelect }) {
        const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition,
        } = useSortable({ id: item.name });

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
        };

        return (
            <li
                ref={setNodeRef}
                style={style}
                className="__tabFields_item"
                {...attributes}
                {...listeners}
            >
                <span className="__tabFields_dragIcon" {...attributes} {...listeners}>
                    <RxDragHandleDots2 />
                </span>

                <input
                    type="checkbox"
                    id={item.name}
                    name="LR_Details"
                    checked={item.check}
                    onChange={() => onToggleMain(item.name)}
                />
                <label htmlFor={item.name} className="anvLabel">
                    {item.name}
                </label>
                {Array.isArray(item.select) && item.check && (
                    <div className="__tabFields_select" >
                        {item.select.map((opt, index) => (
                            <div key={index} className="__tabFields_select_item">
                                <input
                                    type="checkbox"
                                    id={`${item.name}_${opt.name}`}
                                    name={`${item.name}_select`}
                                    checked={opt.check}
                                    onChange={() => onToggleSelect(item.name, opt.name)}
                                />
                                <label htmlFor={`${item.name}_${opt.name}`}>
                                    {opt.name}
                                </label>
                            </div>
                        ))}
                    </div>
                )}

            </li>
        );
    }


    return (
        <>
            <div className='__setOtr_main'>
                <div className='__setBr_main'>
                    <div className='__setf_brancOtr'>
                        <div className='__layOutFr'>
                            <div className='__layOutFr_head'>
                                <h4>Invoice Format</h4>
                                <button onClick={() => handleAddNewFormatClick(false)}>Add New Format</button>
                            </div>

                            <div className='__layOutFr_body'>
                                <div className='__inrFormate_main'>
                                    <div className='__frmInner_fx'>
                                        {isLrBranchLoading && <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
                                            <Loading />
                                        </div>}
                                        {!isLrBranchLoading && <>
                                            {branchLrFormate?.map((br, index) => {
                                                return <div className='__frmOtr_cover' key={br?.id} onClick={() => {
                                                    handleSettingsClick(br)
                                                    setForm(br)
                                                }} style={{ cursor: "pointer" }}>
                                                    <div className='__frm_coverInr'>
                                                        <div className='__frm_container position-relative' style={{ minHeight: '200px' }}>
                                                            <img src={br?.imageUrl} alt={br.name}
                                                                style={{ width: '100%' }} />
                                                        </div>

                                                        <div className='__frm_setting_sd'>
                                                            <div className="__frm_switcher" onClick={(e) => e.stopPropagation()}>
                                                                <div className="anvSwitch_frm form-check form-switch" bis_skin_checked="1" >
                                                                    <input className="form-check-input" type="checkbox" role="switch" id={`makeDefault${index}`} name="makeDefault" autocomplete="off"
                                                                        checked={br?.is_default}
                                                                        disabled={br?.is_default}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(event) => {
                                                                            const checked = event.target.checked ? 1 : 0;
                                                                            setBranchLrFormate(prev =>
                                                                                prev.map((item, i) => ({
                                                                                    ...item,
                                                                                    is_default: i === index && checked ? 1 : 0,
                                                                                }))
                                                                            );

                                                                            if (checked) {
                                                                                handleChangeDefaultStatus(event, br?._id, index);
                                                                            }
                                                                        }} />
                                                                    <label htmlFor={`makeDefault${index}`} onClick={(e) => e.stopPropagation()}>Default</label>
                                                                </div>
                                                            </div>
                                                            <div className='_frm_btns'>
                                                                <button className='_delete_lrForm_btn' onClick={(event) => handleDeleteClick(event, br)}><RiDeleteBin6Line /></button>
                                                                <button className='_edit_lrForm_btn' onClick={() => {
                                                                    handleSettingsClick(br)
                                                                    setForm(br)
                                                                }}><IoSettingsOutline /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className="_frm_txt">{br?.name}</p>
                                                </div>
                                            })
                                            }

                                        </>

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='__setBr_main'>
                    <div className='__setf_brancOtr'>
                        <div className='__layOutFr'>
                            <div className='__layOutFr_head'>
                                <h4>Claim Format</h4>
                                <button onClick={() => handleAddNewFormatClick(false)}>Add New Format</button>
                            </div>

                            <div className='__layOutFr_body'>
                                <div className='__inrFormate_main'>
                                    <div className='__frmInner_fx'>
                                        {isLrBranchLoading && <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
                                            <Loading />
                                        </div>}
                                        {!isLrBranchLoading && <>
                                            {claimFormate?.map((br, index) => {
                                                return <div className='__frmOtr_cover' key={br?.id} onClick={() => {
                                                    handleSettingsClick(br)
                                                    setForm(br)
                                                }} style={{ cursor: "pointer" }}>
                                                    <div className='__frm_coverInr'>
                                                        <div className='__frm_container position-relative' style={{ minHeight: '200px' }}>
                                                            <img src={br?.imageUrl} alt={br.name}
                                                                style={{ width: '100%' }} />
                                                        </div>

                                                        <div className='__frm_setting_sd'>
                                                            <div className="__frm_switcher" onClick={(e) => e.stopPropagation()}>
                                                                <div className="anvSwitch_frm form-check form-switch" bis_skin_checked="1" >
                                                                    <input className="form-check-input" type="checkbox" role="switch" id={`makeDefault${index}`} name="makeDefault" autocomplete="off"
                                                                        checked={br?.is_default}
                                                                        disabled={br?.is_default}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(event) => {
                                                                            const checked = event.target.checked ? 1 : 0;
                                                                            setClaimFormate(prev =>
                                                                                prev.map((item, i) => ({
                                                                                    ...item,
                                                                                    is_default: i === index && checked ? 1 : 0,
                                                                                }))
                                                                            );

                                                                            if (checked) {
                                                                                handleChangeDefaultStatus(event, br?._id, index);
                                                                            }
                                                                        }} />
                                                                    <label htmlFor={`makeDefault${index}`} onClick={(e) => e.stopPropagation()}>Default</label>
                                                                </div>
                                                            </div>
                                                            <div className='_frm_btns'>
                                                                <button className='_delete_lrForm_btn' onClick={(event) => handleDeleteClick(event, br)}><RiDeleteBin6Line /></button>
                                                                <button className='_edit_lrForm_btn' onClick={() => {
                                                                    handleSettingsClick(br)
                                                                    setForm(br)
                                                                }}><IoSettingsOutline /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className="_frm_txt">{br?.name}</p>
                                                </div>
                                            })
                                            }

                                        </>

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='__setBr_main'>
                    <div className='__setf_brancOtr'>
                        <div className='__layOutFr'>
                            <div className='__layOutFr_head'>
                                <h4>Supplementary </h4>
                                <button onClick={() => handleAddNewFormatClick(false)}>Add New Format</button>
                            </div>

                            <div className='__layOutFr_body'>
                                <div className='__inrFormate_main'>
                                    <div className='__frmInner_fx'>
                                        {isLrBranchLoading && <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
                                            <Loading />
                                        </div>}
                                        {!isLrBranchLoading && <>
                                            {supplementaryFormate?.map((br, index) => {
                                                return <div className='__frmOtr_cover' key={br?.id} onClick={() => {
                                                    handleSettingsClick(br)
                                                    setForm(br)
                                                }} style={{ cursor: "pointer" }}>
                                                    <div className='__frm_coverInr'>
                                                        <div className='__frm_container position-relative' style={{ minHeight: '200px' }}>
                                                            <img src={br?.imageUrl} alt={br.name}
                                                                style={{ width: '100%' }} />
                                                        </div>

                                                        <div className='__frm_setting_sd'>
                                                            <div className="__frm_switcher" onClick={(e) => e.stopPropagation()}>
                                                                <div className="anvSwitch_frm form-check form-switch" bis_skin_checked="1" >
                                                                    <input className="form-check-input" type="checkbox" role="switch" id={`makeDefault${index}`} name="makeDefault" autocomplete="off"
                                                                        checked={br?.is_default}
                                                                        disabled={br?.is_default}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(event) => {
                                                                            const checked = event.target.checked ? 1 : 0;
                                                                            setSupplementaryFormate(prev =>
                                                                                prev.map((item, i) => ({
                                                                                    ...item,
                                                                                    is_default: i === index && checked ? 1 : 0,
                                                                                }))
                                                                            );

                                                                            if (checked) {
                                                                                handleChangeDefaultStatus(event, br?._id, index);
                                                                            }
                                                                        }} />
                                                                    <label htmlFor={`makeDefault${index}`} onClick={(e) => e.stopPropagation()}>Default</label>
                                                                </div>
                                                            </div>
                                                            <div className='_frm_btns'>
                                                                <button className='_delete_lrForm_btn' onClick={(event) => handleDeleteClick(event, br)}><RiDeleteBin6Line /></button>
                                                                <button className='_edit_lrForm_btn' onClick={() => {
                                                                    handleSettingsClick(br)
                                                                    setForm(br)
                                                                }}><IoSettingsOutline /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className="_frm_txt">{br?.name}</p>
                                                </div>
                                            })
                                            }

                                        </>

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add New LR Format Offcanvas */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showAddNewFormat ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showAddNewFormat ? "visible" : "hidden" }}
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title">Add Invoice Format</h5>
                    <CrossButton type="button" className="_switchBtn  __animEffect_btn" onClick={() => setShowAddNewFormat(false)} style={{ marginLeft: 'auto' }}>
                        <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                            <path
                                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                fill="black"
                            />
                        </svg>
                    </CrossButton>
                </div>

                <div className="offcanvas-body" style={{ height: 'calc(100vh - 109px)' }}>
                    <div className='__layOutFr_body'>
                        <div className='__inrFormate_main'>
                            <div className='__frmInner_fx'>
                                {isLrLoading && <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
                                    <Loading />
                                </div>}
                                {!isLrLoading && <>
                                    {
                                        formatList?.filter((i) =>
                                            !branchLrFormate?.some((j) => j.id === i.id)
                                        )?.map((fr) => {
                                            // const isAdded = isSelected.some(f => f.id === fr.id);
                                            // const isLoading = loadingId === fr.id;
                                            return <div className='__frmOtr_cover' key={fr?.id}>
                                                <div className='__frm_coverInr'>
                                                    <div className='__frm_container position-relative' style={{ minHeight: '200px', cursor: 'pointer' }} onClick={() => setSelectedFormat(fr)}>
                                                        {/* Image part */}
                                                        <img src={fr?.imageUrl} alt={fr.name} style={{ width: '100%' }} />
                                                    </div>

                                                    <div className='__frm_setting_sd'>
                                                        <button className='_add_lrForm_btn' style={{
                                                            backgroundColor: 'rgba(0, 21, 60, 1)',
                                                            color: '#fff',
                                                            cursor: 'pointer',
                                                            border: 'none',
                                                            padding: '8px 16px',
                                                            transition: 'background-color 0.3s',
                                                        }}
                                                            // disabled={isAdded || isLoading}
                                                            onClick={() => {
                                                                handleSettingsClick(fr)
                                                                setShowAddNewFormat(false)
                                                                setForm(fr)
                                                            }} > Add Format</button>
                                                    </div>
                                                </div>
                                                <p className="_frm_txt">{fr?.name}</p>
                                            </div>
                                        })
                                    }
                                </>
                                }

                                {selectedFormat && (
                                    <div className="__preView_modal" >
                                        <div className='__preView_modal_content'>
                                            <div className='__preView_modal_header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <p style={{ fontWeight: 'bold' }}>{selectedFormat?.name}</p>
                                                <button onClick={() => setSelectedFormat(null)} style={{ background: 'transparent', border: 'none', fontSize: '20px', cursor: 'pointer' }}>
                                                    <svg
                                                        className="cross"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="13"
                                                        height="13"
                                                        viewBox="0 0 13 13"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                                            fill="black"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>

                                            <div style={{ padding: '20px' }}>
                                                <img src={selectedFormat?.imageUrl} alt={selectedFormat?.name} style={{ width: '100%', height: 'auto' }} />
                                            </div>

                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Backdrop */}
            <div className={showAddNewFormat ? "offBack_drop" : ""}></div>
            {/* Add New LR Format Offcanvas */}


            {/* LR Setting Offcanvas */}
            {showLrSetting && <div
                className={`offcanvas offcanvas-end common_offCanvas xl3_Offcanvas ${showLrSetting ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showLrSetting ? "visible" : "hidden" }}
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title">Invoice Print</h5>
                    <CrossButton type="button" className="_switchBtn  __animEffect_btn" onClick={() => {
                        setShowLrSetting(false)
                        setActiveTab(1)

                    }} style={{ marginLeft: 'auto' }}>
                        <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                            <path
                                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                fill="black"
                            />
                        </svg>
                    </CrossButton>
                </div>

                <div className="offcanvas-body" style={{ height: 'calc(100vh - 109px)' }}>

                    <div className='__frm_setting_cover'>
                        <div className="__frm_container">

                            {FormatList[form.id]}

                        </div>

                        <div className='__frm_settFlx __strInvoice'>
                            <div className='__frm_settInr'>

                                <div className='addPr_flBx'>
                                    <Tab {...tabProps} />
                                    {activeTab === 1 && (
                                        <div className='__frmSet_tabContent'>
                                            <div>
                                                <h6 className='mb-3'>Template Name</h6>

                                                <div className='mb-4'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Enter Template Name*"
                                                        name="name"
                                                        value={form.name}
                                                        placeholder="Enter Template Name*"
                                                        onChange={handleChange}
                                                    />
                                                </div>

                                            </div>

                                            <div style={{ borderBottom: '1px solid rgba(232, 234, 237, 1)', margin: '0 -18px 30px', padding: '8px' }}></div>

                                            <div>
                                                <h6 className='mb-3'>Company Details</h6>

                                                <div className='mb-4'>
                                                    <CommonInput
                                                        type="text"
                                                        label="For the Financial Year 2024-2025*"
                                                        name="financial_year"
                                                        value={form.financial_year}
                                                        placeholder="For the Financial Year 2024-2025*"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <h6 className='mb-3'>Static Fields</h6>

                                                {
                                                    [1, 2, 3, 4, 5, 6, 7].map((lineNum) => (
                                                        <div className='mb-2' key={`line${lineNum}`}>
                                                            <CommonInput
                                                                type="text"
                                                                name={`static_fields.line${lineNum}`}
                                                                value={form.static_fields?.[`line${lineNum}`] || ''}
                                                                placeholder={`Line ${lineNum}`}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    ))}
                                            </div>

                                            <div>
                                                <h6 className='mb-3 mt-4'>Prepared By</h6>
                                                <CommonInput
                                                    type="text"
                                                    label="Name of User"
                                                    name="name_user"
                                                    value={form.prepared_by}
                                                    placeholder="Name of User"
                                                    disabled
                                                // onChange={handleChange}
                                                />
                                            </div>

                                            <div>
                                                <h6 className='mb-3 mt-3'>Verified By</h6>
                                                <CommonInput
                                                    type="text"
                                                    label="Name of Verifier"
                                                    name="verified_by"
                                                    value={form.verified_by}
                                                    placeholder="Name of Verifier"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {activeTab === 2 && (
                                        // <BranchOtherDetailsTab onDataFetch={onDataFetch} />
                                        <div className='__frmSet_tabContent'>
                                            <div>
                                                <h6 className='mb-3'>Column Details</h6>

                                                {form?.id == 1 && <div className='__allCols_xt'>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 1"
                                                                name="col1.name"
                                                                value={form?.col1?.name}
                                                                placeholder="Column Name 1"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                name="col1.value"
                                                                value={invoiceFields?.find((i) => i?.value == form?.col1?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col1.value" }
                                                                    }, selectedOption.value);
                                                                }}
                                                            />
                                                        </div>

                                                        {/* <div className='__clm_paraBxs'>
                                                            <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p>
                                                        </div> */}
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 2"
                                                                name="col2.name"
                                                                value={form?.col2?.name}
                                                                placeholder="Column Name 2"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={secondColFields}
                                                                placeholder="LR Date"
                                                                label='LR Date'
                                                                value={secondColFields?.find((i) => i?.value == form?.col2?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col2.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>

                                                        {/* <div className='__clm_paraBxs'>
                                                            <p>LR Date/ Dispatch Date/ Indent Date</p>
                                                        </div> */}
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 3"
                                                                name="col3.name"
                                                                value={form?.col3?.name}
                                                                placeholder="Column Name 3"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col3.value"
                                                                value={form?.col3?.value}
                                                                placeholder="Column Name 3"
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 4"
                                                                name="col4.name"
                                                                value={form?.col4?.name}
                                                                placeholder="Column Name 4"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col4?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col4.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>
                                                            {/* <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p> */}
                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 5"
                                                                name="col5.name"
                                                                value={'Origin'}
                                                                placeholder="Column Name 5"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="column10"
                                                                value={'From Station'}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 6"
                                                                name="col6.name"
                                                                value={'Destination'}
                                                                placeholder="Column Name 6"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"To Station"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 7"
                                                                name="col7.name"
                                                                value={"Vehicle Number"}
                                                                placeholder="Column Name 7"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Vehicle Number"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 8"
                                                                name="col8.name"
                                                                value={"Type of Vehicle"}
                                                                placeholder="Column Name 8"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Type of Vehicle"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 9"
                                                                name="col9.name"
                                                                value={"PKG"}
                                                                placeholder="Column Name 9"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Qty"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 10"
                                                                name="col10.name"
                                                                value={"Weight KG"}
                                                                placeholder="Column Name 10"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Weight KG"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 11"
                                                                name="col11.value"
                                                                value={form?.col11?.name}
                                                                placeholder="Column Name 11"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col11?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col11.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 12"
                                                                name="column12"
                                                                value={"Amount"}
                                                                placeholder="Column Name 12"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Total Freight"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                </div>}
                                                {form?.id == 2 && <div className='__allCols_xt'>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 1"
                                                                name="col1.name"
                                                                value={"Serial No "}
                                                                placeholder="Column Name 1"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col1.name"
                                                                value={"Serial No "}
                                                                placeholder="Column Name 1"
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        {/* <div className='__clm_paraBxs'>
                                                            <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p>
                                                        </div> */}
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 2"
                                                                name="col2.name"
                                                                value={form?.col2?.name}
                                                                placeholder="Column Name 2"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={secondColFields}
                                                                placeholder="LR Date"
                                                                label='LR Date'
                                                                value={secondColFields?.find((i) => i?.value == form?.col2?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col2.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>

                                                        {/* <div className='__clm_paraBxs'>
                                                            <p>LR Date/ Dispatch Date/ Indent Date</p>
                                                        </div> */}
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 3"
                                                                name="col3.name"
                                                                value={"FROM CODE"}
                                                                placeholder="Column Name 3"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col3.value"
                                                                value={"FROM CODE"}
                                                                placeholder="Column Name 3"
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 4"
                                                                name="col4.name"
                                                                value={"FROM NAME"}
                                                                placeholder="Column Name 4"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col4.name"
                                                                value={"FROM NAME"}
                                                                placeholder="Column Name 4"
                                                            // onChange={handleChange}
                                                            />
                                                            {/* <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col4?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col4.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            /> */}
                                                        </div>

                                                        <div className='__clm_paraBxs'>
                                                            {/* <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p> */}
                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 5"
                                                                name="col5.name"
                                                                value={"TO CODE"}
                                                                placeholder="Column Name 5"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col5.value"
                                                                value={"TO CODE"}
                                                                placeholder="Column Name 5"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 6"
                                                                name="col6.name"
                                                                value={"TO NAME"}
                                                                placeholder="Column Name 6"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col6.name"
                                                                value={"TO NAME"}
                                                                placeholder="Column Name 6"
                                                            // onChange={handleChange}
                                                            />

                                                        </div>

                                                        <div className='__clm_paraBxs'>
                                                            {/* <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p> */}
                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 7"
                                                                name="col11.value"
                                                                value={"Po Number"}
                                                                placeholder="Column Name 7"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col7?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col7.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 8"
                                                                name="col11.value"
                                                                value={"STO Number"}
                                                                placeholder="Column Name 8"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col8?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col8.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 9"
                                                                name="col9.value"
                                                                value={"GAN Number"}
                                                                placeholder="Column Name 9"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col9?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col9.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 8"
                                                                name="col8.name"
                                                                value={"Type of Vehicle"}
                                                                placeholder="Column Name 8"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Type of Vehicle"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 9"
                                                                name="col9.name"
                                                                value={"Received QTY in GAN	"}
                                                                placeholder="Column Name 9"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Qty"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 9"
                                                                name="col9.name"
                                                                value={"KOT"}
                                                                placeholder="Column Name 9"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"KOT"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 12"
                                                                name="column12"
                                                                value={"Freight"}
                                                                placeholder="Column Name 12"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"Total Freight"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                </div>}
                                                {form?.id == 3 && <div className='__allCols_xt'>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 1"
                                                                name="col1.name"
                                                                value={"Serial No "}
                                                                placeholder="Column Name 1"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col1.name"
                                                                value={"Serial No "}
                                                                placeholder="Column Name 1"
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        {/* <div className='__clm_paraBxs'>
                                                            <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p>
                                                        </div> */}
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 2"
                                                                name="col2.name"
                                                                value={form?.col2?.name}
                                                                placeholder="Column Name 2"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={secondColFields}
                                                                placeholder="LR Date"
                                                                label='LR Date'
                                                                value={secondColFields?.find((i) => i?.value == form?.col2?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col2.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>

                                                        {/* <div className='__clm_paraBxs'>
                                                            <p>LR Date/ Dispatch Date/ Indent Date</p>
                                                        </div> */}
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 3"
                                                                name="col9.value"
                                                                value={"SHIPMENT NO."}
                                                                placeholder="Column Name 3"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col3?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col3.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 4"
                                                                name="col3.name"
                                                                value={"VEHICLE NO."}
                                                                placeholder="Column Name 3"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col3.value"
                                                                value={"VEHICLE NO.	"}
                                                                placeholder="Column Name 4"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 5"
                                                                name="col3.name"
                                                                value={"LR. NO."}
                                                                placeholder="Column Name 5"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col3.value"
                                                                value={"LR. NO."}
                                                                placeholder="Column Name 5"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 6"
                                                                name="col3.name"
                                                                value={"TO"}
                                                                placeholder="Column Name 6"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col3.value"
                                                                value={"TO"}
                                                                placeholder="Column Name 6"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 7"
                                                                name="col3.name"
                                                                value={"REPORTING DATE	"}
                                                                placeholder="Column Name 7"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col3.value"
                                                                value={"REPORTING DATE	"}
                                                                placeholder="Column Name 7"
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 8"
                                                                name="col4.name"
                                                                value={"UNLOADING DATE"}
                                                                placeholder="Column Name 8"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col4.name"
                                                                value={"UNLOADING DATE"}
                                                                placeholder="Column Name 8"
                                                            // onChange={handleChange}
                                                            />
                                                            {/* <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col4?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col4.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            /> */}
                                                        </div>

                                                        <div className='__clm_paraBxs'>
                                                            {/* <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p> */}
                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 9"
                                                                name="col5.name"
                                                                value={"OUTWARD FREIGHT AMOUNT"}
                                                                placeholder="Column Name 9"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col5.value"
                                                                value={"OUTWARD FREIGHT AMOUNT"}
                                                                placeholder="Column Name 9"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 10"
                                                                name="col6.name"
                                                                value={"DETENTION AMOUNT"}
                                                                placeholder="Column Name 10"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Field Value"
                                                                name="col6.name"
                                                                value={"DETENTION AMOUNT"}
                                                                placeholder="Column Name 6"
                                                            // onChange={handleChange}
                                                            />

                                                        </div>

                                                        <div className='__clm_paraBxs'>
                                                            {/* <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p> */}
                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 11"
                                                                name="col8.name"
                                                                value={"ACTUAL / LOADING UNLOADING AMOUNT"}
                                                                placeholder="Column Name 11"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"ACTUAL / LOADING UNLOADING AMOUNT"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 12"
                                                                name="col9.name"
                                                                value={"TRANSIT PENALTY"}
                                                                placeholder="Column Name 12"
                                                            // onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"TRANSIT PENALTY"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>

                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 13"
                                                                name="col9.name"
                                                                value={"TOTAL GST (INR)"}
                                                                placeholder="Column Name 9"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"TOTAL GST (INR)"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                    <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                        <div className='__clm_bxs' style={{ width: '147px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                label="Column Name 12"
                                                                name="column12"
                                                                value={"TOTAL (INR)"}
                                                                placeholder="Column Name 12"
                                                            />
                                                        </div>
                                                        <div className='__clm_bxs' style={{ width: '187px' }}>
                                                            <CommonInput
                                                                type="text"
                                                                name="col6.value"
                                                                value={"TOTAL (INR)"}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                disabled={true}
                                                            />
                                                        </div>

                                                        <div className='__clm_paraBxs'>

                                                        </div>
                                                    </div>
                                                </div>}
                                                {form?.id == 4
                                                    && <div className='__allCols_xt'>
                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 1"
                                                                    name="col1.name"
                                                                    value={"Serial No "}
                                                                    placeholder="Column Name 1"
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col1.name"
                                                                    value={"Serial No "}
                                                                    placeholder="Column Name 1"
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* <div className='__clm_paraBxs'>
                                                            <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p>
                                                        </div> */}
                                                        </div>

                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 2"
                                                                    name="col2.name"
                                                                    value={form?.col2?.name}
                                                                    placeholder="Column Name 2"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CustomSelect
                                                                    options={invoiceFields}
                                                                    placeholder="LR Date"
                                                                    label='LR Date'
                                                                    value={invoiceFields?.find((i) => i?.value == form?.col2?.value)}
                                                                    onSelect={(selectedOption) => {
                                                                        handleChange({
                                                                            target: { name: "col2.value" }
                                                                        }, selectedOption?.value);
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* <div className='__clm_paraBxs'>
                                                            <p>LR Date/ Dispatch Date/ Indent Date</p>
                                                        </div> */}
                                                        </div>
                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 3"
                                                                    name="col9.value"
                                                                    value={"TRUCK NO"}
                                                                    placeholder="Column Name 3"
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col3.value"
                                                                    value={"TRUCK NO"}
                                                                    placeholder="Column Name 4"
                                                                // onChange={handleChange}
                                                                />

                                                            </div>
                                                        </div>
                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 4"
                                                                    name="col3.name"
                                                                    value={"TYPE OF VEHICLE"}
                                                                    placeholder="Column Name 3"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col3.value"
                                                                    value={"TYPE OF VEHICLE"}
                                                                    placeholder="Column Name 4"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>

                                                            <div className='__clm_paraBxs'>

                                                            </div>
                                                        </div>
                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 5"
                                                                    name="col3.name"
                                                                    value={"DATE"}
                                                                    placeholder="Column Name 5"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col3.value"
                                                                    value={"DATE"}
                                                                    placeholder="Column Name 5"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>

                                                            <div className='__clm_paraBxs'>

                                                            </div>
                                                        </div>
                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 6"
                                                                    name="col3.name"
                                                                    value={"FROM LOCATION	"}
                                                                    placeholder="Column Name 6"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col3.value"
                                                                    value={"FROM LOCATION	"}
                                                                    placeholder="Column Name 6"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>

                                                            <div className='__clm_paraBxs'>

                                                            </div>
                                                        </div>
                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 7"
                                                                    name="col3.name"
                                                                    value={"TO LOCATION	"}
                                                                    placeholder="Column Name 7"
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col3.value"
                                                                    value={"TO LOCATION	"}
                                                                    placeholder="Column Name 7"
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            <div className='__clm_paraBxs'>

                                                            </div>
                                                        </div>

                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 8"
                                                                    name="col4.name"
                                                                    value={"PKG"}
                                                                    placeholder="Column Name 8"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col4.name"
                                                                    value={"PKG"}
                                                                    placeholder="Column Name 8"
                                                                // onChange={handleChange}
                                                                />
                                                                {/* <CustomSelect
                                                                options={invoiceFields}
                                                                placeholder="Field Value"
                                                                label='Field Value'
                                                                value={invoiceFields?.find((i) => i?.value == form?.col4?.value)}
                                                                onSelect={(selectedOption) => {
                                                                    handleChange({
                                                                        target: { name: "col4.value" }
                                                                    }, selectedOption?.value);
                                                                }}
                                                            /> */}
                                                            </div>

                                                            <div className='__clm_paraBxs'>
                                                                {/* <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p> */}
                                                            </div>
                                                        </div>

                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 9"
                                                                    name="col5.name"
                                                                    value={"FREIGHT"}
                                                                    placeholder="Column Name 9"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col5.value"
                                                                    value={"FREIGHT"}
                                                                    placeholder="Column Name 9"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>

                                                            <div className='__clm_paraBxs'>

                                                            </div>
                                                        </div>

                                                        <div className='__columnDt_bxs' style={{ marginBottom: '18px' }}>
                                                            <div className='__clm_bxs' style={{ width: '147px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Column Name 10"
                                                                    name="col6.name"
                                                                    value={"TOTAL"}
                                                                    placeholder="Column Name 10"
                                                                // onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                <CommonInput
                                                                    type="text"
                                                                    label="Field Value"
                                                                    name="col6.name"
                                                                    value={"TOTAL"}
                                                                    placeholder="Column Name 6"
                                                                // onChange={handleChange}
                                                                />

                                                            </div>

                                                            <div className='__clm_paraBxs'>
                                                                {/* <p>Invoice Number/ PO Number/Field 1,2,3,4,5, / Indent Number/ MLR/ LR/ Eway Number POD Number</p> */}
                                                            </div>
                                                        </div>
                                                    </div>}
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>

                            <div className="offcanvas-footer">
                                <button className="_addComm_btn" onClick={() => handleUpdate(activeTab)} disabled={isUpdateLoading}>
                                    {isUpdateLoading ? "Adding..." : activeTab == 1 ? "Continue" : "Add Template"}
                                </button>

                                <button className="_cancel_btn" onClick={() => setShowLrSetting(false)}>Cancel</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>}

            {/* Backdrop */}
            {showLrSetting && <div className={showLrSetting ? "offBack_drop" : ""}></div>}

            {/* LR Setting Offcanvas */}

            {confirmModalShow && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <p className="_confirmPrx">
                            {" "}
                            Are you sure you want to delete {confirmModalShow?.name}
                        </p>
                    </>
                </ConfirmModalFor>
            )}
        </>
    )
}

export default InvoiceFormat